import { ISO_8601 } from 'moment';
import * as moment from 'moment';

export const STORAGE_SYNC_FLAG = 'onetimestoragesync';
export const SECURE_STORAGE_LEGACY_NAME = 'smartcr_secure_store';

// Date format output and accepted by ion-datetime
export const INPUT_DATE_FORMAT = 'YYYY-MM-DD';
export const ALLOWED_INPUT_DATE_FORMATS: Array<any> = ['YYYY-MM-DD', ISO_8601];
export const DISPLAY_DATE_TIME = 'DD MMM YYYY, h A'; // 01 Jan 2018 12PM
export const DISPLAY_DOB = 'MMM DD YYYY'; // Jan 01 2018
export const DISPLAY_DUE_DATE = 'MMM DD YYYY'; // Jan 01 2018
export const DISPLAY_MEDICINE_TIME = 'hh:mm A'; // 12:00 PM

// Clinician vs Health Care Provider
export const CLINICIAN = 'Mentor'; // Clinician that belongs to an Organisation
export const HEALTH_CARE_PROVIDER = 'Healthcare Provider'; // Organisation

// Undo Delete Toast Duration: You can currently undo delete Medicines and Diary Entries
export const DELETE_TOAST_DURATION_SECONDS = 5; // seconds

// IonDateTime component has an open issue regarding not being able to handle UTC...
//  ¯\_(ツ)_/¯
// https://github.com/ionic-team/ionic/issues/11408
export const CURRENT_DATE_TIME_LOCAL = moment().local().set({ minute: 0, second: 0, millisecond: 0 }).format();
export const RECORDED_AT_LABEL = 'When did this happen?';

// Error Messages
export const STATUS_500_MESSAGE = 'We\'ve detected a temporary problem sending your information to your clinicians at the moment. We\'re aware of the problem and when it\'s solved we\'ll start sending again.';
export const DEFAULT_LANGUAGE_LOCALE = 'en-AU';
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_PHONE_COUNTRY_CODE = 'AU';
export const SUPPORTED_LOCALES_MAP = {
  'en-AU': 'English (AU)',
  'en-NZ': 'English (NZ)',
  'es-ES': 'Spanish (ES)',
  'nl-NL': 'Dutch (NL)',
  'nl-BE': 'Dutch (BE)',
  'sv-SE': 'Swedish (SE)',
  'pl-PL': 'Polish (PL)',
};
export const SUPPORTED_LOCALES = Object.keys(SUPPORTED_LOCALES_MAP);
export const LOCALE_LANGUAGE_MAP = {
  en: ['en-AU', 'en-NZ'],
  es: ['es-ES'],
  nl: ['nl-NL', 'nl-BE'],
  sv: ['sv-SE'],
  pl: ['pl-PL']
};
export const SUPPORTED_LANGUAGES = Object.keys(LOCALE_LANGUAGE_MAP);

// Ensure CACHE_NAME is matches service-worker.js
export const CACHE_NAME = 'ionic-cache';
// Limits for Validation Form
export const SYSTOLIC_UPPER_LIMIT = 210;
export const SYSTOLIC_LOWER_LIMIT = 80;
export const DIASTOLIC_UPPER_LIMIT = 130;
export const DIASTOLIC_LOWER_LIMIT = 40;
export const HEART_RATE_UPPER_LIMIT = 160;
export const HEART_RATE_LOWER_LIMIT = 40;

// Default DOB
const startOfToday: moment.Moment = moment().startOf('day');
export const FIFTY_FIVE_YEARS_AGO: string = startOfToday
  .subtract(55, 'years')
  .format(INPUT_DATE_FORMAT);